<template>
    <div>

        <b-modal id="modal-sm" size="md" title="Manage Providers" v-model="showModal" no-close-on-esc no-close-on-backdrop hide-header-close>
            <div slot="default">
                <div class='alert alert-warning' role='alert' v-if=!succeeded> {{Msg}} <br> Please Contact System Administrator. </div>
                <div class="alert alert-success" role="alert" v-if=succeeded> {{Msg}} </div>
            </div> 
            <div slot="modal-footer" class="w-100">
                <p class="float-left" variant="primary"></p>
                <b-button variant="primary"  size="md"  class="float-right"  @click="providerExit"> Close </b-button>
            </div>
        </b-modal>

        <div class="form-group row my-1">
            <label for="GivenName" class="col-sm-4 label-small my-0">Given Name:</label>
                <div class="col-sm-4 my-0">
                <input id="GivenName" :disabled="isExpired" maxlength="25" type="text" placeholder="Given Name" v-model="givenname" class="mb-0 form-control form-control-xs">
                
            </div>
            <div  class="col-sm-4" v-show="$v.givenname.$error">
                <div  class="row">
                    <small class="sml-red" v-if="!$v.givenname.required">Given name is required</small>
                </div> 
            </div>
        </div>

        <div class="form-group row my-1">
            <label for="SurName" class="col-sm-4 label-small my-0">Surname:</label>
                <div class="col-sm-4 my-0">
                <input id="SurName" :disabled="isExpired" type="text" placeholder="Surname" v-model="surname" class="mb-0 form-control form-control-xs">
                
            </div>
            <div  class="col-sm-4" v-show="$v.surname.$error">
                <div  class="row">
                    <small class="sml-red" v-if="!$v.surname.required">Surname is required</small>
                </div> 
            </div>
        </div>

                <div class="form-group row my-1">
            <label for="ProviderNumber" class="col-sm-4 label-small my-0">Provider Number:</label>
                <div class="col-sm-4 my-0">
                <input id="ProviderNumber"   maxlength="10" :disabled="EditMode=='Edit'" type="text" placeholder="Provider Number" v-model="providernumber" class="mb-0 form-control form-control-xs">
                
            </div>
            <div  class="col-sm-4" v-show="$v.providernumber.$error">
                <div  class="row">
                    <small class="sml-red" v-if="!$v.providernumber.required">Provider number is required</small>
                    <small class="sml-red" v-if="!$v.providernumber.minLength">Provider number must have at least 5 digits</small>
                    <small class="sml-red" v-if="!$v.providernumber.numeric">Provider number numeric</small>
                </div> 
            </div>
        </div>

        <div class="form-group row  my-1">
            <label for="roles" class="col-sm-4 col-form-label col-form-label-sm">Service Type</label>
            <div class="col-sm-4">
                <select  id="service" :disabled="EditMode=='Edit'  && this.iseffective" v-model="servicetype" v-on:change="fillSubTypes()"  class="form-control form-control-sm"> 
                    <option v-for="option in ServiceTypes" v-bind:value="{id: option.id, text: option.text, type:option.type}" :key="option.id">
                        {{ option.text }}
                    </option> 
                </select>       
                           </div>
                <div  class="col-sm-4" v-show="$v.servicetype.$error">
                <div  class="row">
                    <small class="sml-red" v-if="!$v.servicetype.required">Service type is required</small> 
                </div> 
              </div>
        </div>

        <div class="form-group row  my-1">
            <label for="servicesubtype" class="col-sm-4 col-form-label col-form-label-sm">Sub Type</label>
            <div class="col-sm-4">
                <select  id="roles" :disabled="EditMode=='Edit'  && this.iseffective" v-model="servicesubtype"  class="form-control form-control-sm"> 
                    <option v-for="option in ServiceSubTypes" v-bind:value="{id: option.id, text: option.text, type:option.type}" :key="option.id">
                        {{ option.text }}
                    </option> 
                </select>       
                
            </div>
                <div  class="col-sm-4" v-show="$v.servicesubtype.$error">
                <div  class="row">
                    <small class="sml-red" v-if="!$v.servicesubtype.required">Service sub type is required</small> 
                </div> 
              </div>
        </div> 

         <div class="form-group row my-1">
                <label for="EffectiveDate" class="col-sm-4 label-small my-0">Effective Date:</label>
                <div class="col-sm-4 my-0">
                    <datepicker typeable :disabled="EditMode=='Edit'  && this.iseffective"  :open-date="new Date()" :disabledDates="{ to: new Date(Date.now() - 8640000) }" v-model="effectivedate" :format="dateFormat" id="effDate" :bootstrap-styling="true" :input-class="datapickClass" name="effectiveDatepicker"></datepicker> 
                </div>
                <div  class="col-sm-4" v-show="$v.effectivedate.$error">
                <div class="row">
                        <small class="sml-red" v-if="!$v.effectivedate.required">Effective date is required</small>
                    </div> 
                </div>
        </div>
            <div class="form-group row my-1">
                <label for="ExpiryDate" class="col-sm-4 label-small my-0">Expiry Date:</label>
                <div class="col-sm-4 my-0">
                    <datepicker typeable v-bind:disabled="isExpired" :open-date="new Date()" :disabledDates="{ to: new Date(Date.now() - 8640000) }" v-model="expirydate" :format="dateFormat" id="effDate" :bootstrap-styling="true" :input-class="datapickClass" name="expirydatepicker"></datepicker> 
                </div>
                <div  class="col-sm-4" v-show="$v.expirydate.$error">
                <div class="row">
                        <small class="sml-red" v-if="!$v.expirydate.required">Expiry date is required</small>
                        <!-- <small class="sml-red" v-if="!$v.expirydate.minValue1 && $v.expirydate.required">Expiry Date date can't be in the past</small> -->
                        <small class="sml-red" v-if="!$v.expirydate.minValue2 && $v.expirydate.required">Expiry Date date must be greater than the effective date</small>
                    </div> 
            </div>
        </div> 

        <div class="form-group row my-1">
            <label for="Address1" class="col-sm-4 label-small my-0">Address:</label>
                <div class="col-sm-4 my-0">
                <input id="Address1" type="text" :disabled="isExpired" maxlength="45" placeholder="Address1" v-model="address1" class="mb-0 form-control form-control-xs">
                
            </div>
            <div  class="col-sm-4" v-show="$v.address1.$error">
                <div  class="row">
                    <small class="sml-red" v-if="!$v.address1.required">Address is required</small>
                </div> 
            </div>
        </div>

        <div class="form-group row my-1">
            <label for="Address2" class="col-sm-4 label-small my-0">Address 2:</label>
                <div class="col-sm-4 my-0">
                <input id="Address2" type="text" :disabled="isExpired" maxlength="25" placeholder="Address2" v-model="address2" class="mb-0 form-control form-control-xs">
                
            </div>
            
        </div>
        

        <div class="form-group row my-1">
            <label for="Address3" class="col-sm-4 label-small my-0">City:</label>
                <div class="col-sm-4 my-0">
                <input id="Address3" type="text" :disabled="isExpired" maxlength="25" placeholder="Address3" v-model="address3" class="mb-0 form-control form-control-xs">
            </div>
            <div  class="col-sm-4" v-show="$v.address3.$error">
                <div  class="row">
                    <small class="sml-red" v-if="!$v.address3.required">City is required</small>
                </div> 
            </div>
        </div>

            <div class="form-group row my-1">
                <label for="Province" class="col-sm-4 label-small my-0">Province:</label>
                <div class="col-sm-4 my-0">
                    <select  id="prov"   :disabled="isExpired"  v-model="provincecode"  class="form-control form-control-sm"> 
                    <option v-for="option in Prov" v-bind:text="{text: option}" :key="option">
                    {{ option}}
                    </option> 
                    </select> 
                </div>
            </div>

            <div class="form-group row my-1">
                <label for="PostalCode" class="col-sm-4 label-small my-0">Postal Code:</label>
                <div class="col-sm-4 my-0">
                    <input id="PostalCode" type="tel" :disabled="isExpired" v-model="postalcode" placeholder="Postal Code" class="mb-0 form-control form-control-xs">
                </div>
                <div  class="col-sm-4" v-show="$v.postalcode.$error">
                <div class="row">
                        <small class="sml-red" v-if="!$v.postalcode.isPostal">Postal code is invalid</small>
                        <small class="sml-red" v-if="!$v.postalcode.required">Postal code is required</small>
                    </div> 
                </div>
            </div>
            <div class="form-group row my-1">
                <label for="PhoneNumber" class="col-sm-4 label-small my-0">Phone:</label>
                 <div class="col-sm-4 my-0">
                    <input id="PhoneNumber" :disabled="isExpired" type="tel" v-model="businessphonenumber" placeholder="Phone Number" class="mb-0 form-control form-control-xs">
                </div>
                <div  class="col-sm-4" v-show="$v.businessphonenumber.$error">
                <div class="row">
                    <small class="sml-red" v-if="!$v.businessphonenumber.required">Phone number is required</small>
                    <small class="sml-red" v-if="!$v.businessphonenumber
                    .isPhone">Phone number is invalid</small>
                    </div> 
                </div>
            </div>

                            <div class="form-group row  my-1">
                    <label for="roles" class="col-sm-4 col-form-label col-form-label-sm">Specialist Billing Allowed:</label>
                    <div class="col-sm-4">
                        <select  id="roles" :disabled="EditMode=='Edit'  && this.iseffective"  v-model="specialtyallowed"  class="form-control form-control-sm"> 
                            <option v-for="option in YesNo" v-bind:value="{id: option.id, text: option.text}" :key="option.id">
                               {{ option.text }}
                            </option> 
                        </select> 

                    </div>
                     <div  class="col-sm-4">
                                 <div class="row">
                            <small class="sml-red" v-if="!$v.specialtyallowed.required">Specialist type site is required</small>
                    </div> 
                     </div>
                    </div>  
        <hr>
        <div class="row" >
            <div class="col-sm-6" >
                    <button v-bind:disabled="disableSave" v-on:click="SavePopup" type="button" class="btn BtnSave  btn-sml"><i :class="saveIcon"></i> {{btnName}} </button>
            </div>
            <div class="col-sm-6">
                <button v-on:click="ClosePopup" type="button" class="btn BtnClose btn-sml float-right"><i class="fas fa-times"></i> Close Form </button>
            </div>
        </div> 
    </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';
import Vuelidate from 'vuelidate'
import { helpers } from 'vuelidate/lib/validators'
const isPhone = helpers.regex('alphaNum', /\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/)
const isPostal = helpers.regex('alphaNum', /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/)
Vue.use(Vuelidate)
import { required, minLength, maxLength, between,withParams,email,numeric} from 'vuelidate/lib/validators'
import { constants } from 'crypto';
export default {
    data: function(){
        return{
            saveIcon:'fas fa-plus',
            btnName: 'Add Provider',
            datapickClass:"form-control form-control-xs my-0",
            givenname:'',
            surname:'',
            providernumber:'',
            servicetype:'',
            servicesubtype:'',
            effectivedate:'',
            expirydate:'',
            address1:'',
            address2:'',
            address3:'',
            provincecode:'',
            postalcode:'',
            businessphonenumber:'',
            specialtyallowed:'',
            disableSave:false,
            dateFormat:'',
            ServiceTypes:[],
            ServiceSubTypes:[],
            servicetypeids:[],
            givename:'',
            showModal:false,
             succeeded:true,
             Msg:''             ,
            Prov:['AB', 'BC', 'MB', 'NB', 'NL', 'NT', 'NS', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT'],
            YesNo:'',
            EditMode:'',
            isExpired:false,
            iseffective:false
        }
    },
    props:{
        UserData:'',
        mode:''
    },
    components:{
        Datepicker
    },

    created: function(){
        this.dateFormat = this.$store.getters.GetDateFormat;
        this.EditMode= this.mode;
        if(this.EditMode  == 'Edit')
        {
            this.btnName = 'Edit Provider';
            this.saveIcon = 'far fa-edit'; 
        } 
        this.givenname = this.UserData.givenname;
        this.surname = this.UserData.surname;
        this.providernumber = this.UserData.providernumber==undefined?'':this.UserData.providernumber
        this.providernumber = ('0000000000' + this.providernumber.toString()).substring(this.providernumber.toString().length);
        this.expirydate = moment(this.UserData.expirydate==undefined?'9999/12/31':this.UserData.expirydate, "YYYY-MM-DD").format('YYYY/MM/DD');
        this.effectivedate = moment(this.UserData.effectivedate==undefined?moment().startOf('day').toISOString():this.UserData.effectivedate, "YYYY-MM-DD").format('YYYY/MM/DD');
        this.isExpired = (moment(this.expirydate)).toISOString() <= moment().startOf('day').toISOString();
        this.iseffective = (moment(this.effectivedate)).toISOString() <= moment().startOf('day').toISOString();
        this.disableSave = this.isExpired;
        var vm = this;
            
            axios.get('SaskHealthApi/Codes/GetServicesComboWithoutDPEBB?_='+Date.now(), { headers: { 'Authorization': 'Bearer ' + localStorage.access_token }})
            .then(function (response) {
                vm.ServiceTypes=response.data.items;
                vm.servicetype = vm.ServiceTypes.find(x=>x.text === vm.UserData.servicetype);
             })
            .catch(function (er) {

                //console.log(er)
                
            }).then(function () {
                vm.fillSubTypes();
                }); 
                this.effectivedate = moment(this.UserData.effectivedate==undefined?new Date():this.UserData.effectivedate, "YYYY-MM-DD").format('YYYY/MM/DD');
                this.address1 = this.UserData.address1;
                this.address2 = this.UserData.address2;
                this.address3 = this.UserData.address3;
                this.provincecode = this.UserData.provincecode==undefined?'SK': this.UserData.provincecode;
                this.postalcode = this.UserData.postalcode;
                this.businessphonenumber = this.UserData.businessphonenumber;
                
                this.YesNo = [{id:'Y', text:'Yes'},{id:'N', text:'No'}];
                this.specialtyallowed = this.YesNo.find(x=>x.id === (this.UserData.specialtyallowed == undefined?'N':this.UserData.specialtyallowed));

            },
         
            
methods:{
  ClosePopup: function() {     
      this.$root.$emit('bv::hide::modal', 'editModal', '#btnShow') 
         this.$v.$reset();

                
                
    },
    SavePopup: function(){
     
        this.$v.$touch();
		if (!this.$v.$invalid){
           this.disableSave = true;

		var offset = (new Date()).getTimezoneOffset() / 60;
 
        var effDate =  moment(this.effectivedate).startOf('day').subtract('hours',offset);
        var expDate = moment(this.expirydate).startOf('day').subtract('hours',offset);
          
        this.postalcode = this.postalcode.replace(/[^0-9a-z]/gi,'');
        this.businessphonenumber = (this.businessphonenumber.replace(/[^0-9]/gi,'')).slice((-10))

          var vm = this;
           var url = "SaskHealthApi/Host/PostEditProviders/"
          var params = {
                "_": Date.now(), 
                "providernumber": vm.providernumber,
                "effectivedate": effDate,
                "expirydate": expDate,
                "givenname": vm.givenname,
                "surname" : vm.surname,
                "address1" : vm.address1,
                "address2" : vm.address2==undefined?"":vm.address2,
                "address3" : vm.address3,
                "provincecode" : vm.provincecode,
                "postalcode" : vm.postalcode,
                "businessphonenumber" : vm.businessphonenumber,
                "servicetype" : vm.servicetype.type,
                "servicetypeid":vm.servicetype.id,

                "servicesubtype" : vm.servicesubtype.type,
                "servicesubtypeid" : vm.servicesubtype.id,
                "specialist" : vm.specialtyallowed.id,
                "mode": vm.EditMode == "Add"?'A':'U'
                } 
                axios({
                    method: 'post',
                    url: url,
                    headers: { 'Authorization': 'Bearer ' + vm.$store.getters.GetAccessToken },
                    data: params
                    }).then(function (response) {
                                vm.succeeded = true;
                                vm.Msg= "Provider Number: " + vm.providernumber + ". " + response.data;                            
                                vm.showModal=true;
                })
                .catch(function (er) {
                     vm.disableSave = false;
                     vm.succeeded = false;
                     vm.Msg="Warning: Save UnSuccessfully For Provider Number " +  vm.providernumber+" ( " + er.response.data.message + ").";  
                     vm.showModal=true;
               
                }).then(function () {

                }); 
      }
    },
    providerExit: function(){
        this.showModal=false;
          if(this.succeeded){
           this.$emit('providerUpdated');
        }
    },
    fillSubTypes: function(){
        var vm = this;
        var params = new URLSearchParams();
        vm.servicetypeids=[];
        vm.servicetypeids.push(vm.servicetype==undefined?0:vm.servicetype.id)
        params.append('ServiceID',vm.servicetypeids);
                axios.get('SaskHealthApi/Codes/GetServiceSubtypesCombo?_='+Date.now(), { headers: { 'Authorization': 'Bearer ' + localStorage.access_token },params})
                .then(function (response) {
                    vm.ServiceSubTypes=response.data.items;
                    vm.servicesubtype = vm.ServiceSubTypes.find(x=>x.text === vm.UserData.servicesubtype);
                })
                .catch(function (er) {

                    //console.log(er)
                    
                });
    },
    },
  validations(){
       return {
           givenname:{
                    required
                },
            surname:{
                required
           },
           providernumber:{
                required,
                numeric,
                minLength: minLength(5)
            },
            servicetype:{
                required
            },
            servicesubtype:{
                required
            },
            effectivedate:{
                required
            },
            expirydate:{
                required,
                //minValue1: value => (moment(this.expirydate)).toISOString() >= moment().startOf('day').toISOString()  || this.isExpired, 
                minValue2: value => moment(this.expirydate).toISOString() >= (moment(this.effectivedate)).toISOString()
            },
            address1:{
                required
            },
            address3:{
                required
            },
            postalcode:{
                required,
                isPostal
            },
            businessphonenumber:{
                required,
                isPhone
            },
            
                specialtyallowed:{
                    required
                }

        }
    }
}
</script>

<style>

</style>
